import { Epic, ofType } from 'redux-observable';
import { RootAction, RootState, Services } from 'typesafe-actions';
import { of, from } from 'rxjs';
import { catchError, switchMap, mergeMap } from 'rxjs/operators';
import { User } from '@amzn/coral_com-amazon-passportusermanagementservice';
import { updateUserLocaleAction } from '../../../actions/userManagementActions';
import { UPDATE_USER_LOCALE_REQUEST } from '../../../actions/userManagementActions/actionTypes';

export const updateUserLocaleEpic: Epic<
  RootAction,
  RootAction,
  RootState,
  Services
> = (action$, state$, { api }) =>
  action$.pipe(
    ofType(UPDATE_USER_LOCALE_REQUEST),
    switchMap((action) =>
      from(
        api.userManagementServices
          .updateUserProfileInfo({
            ...(action.payload as User),
            monsSelectLocale: action.payload.defaultLocale,
          })
          .pipe(
            mergeMap((response) =>
              of(updateUserLocaleAction.success(response.user))
            ),
            catchError((err) => of(updateUserLocaleAction.failure(err)))
          )
      )
    )
  );

export default updateUserLocaleEpic;
